<template>
  <div class="box company-detail">
    <div class="box-header">
      <h3 class="box-title">Video Link</h3>
      <p>W:1280 x H:720</p>
    </div>
    <div class="item">
      <input
        type="text"
        class="input"
        v-model="videoLink"
        placeholder="Videl Link"
      />
    </div>
    <div class="video">
      <iframe
        src="https://www.youtube.com/embed/qslT-yj9Oy8?si=V3vrwEQKSL7cjuvR"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isLinks"],
  data() {
    return {
      videoLink: "",
    };
  },
  watch: {
    videoLink: {
      handler(value) {
        this.$emit("input", value);
      },
      immediate: true,
      deep: true,
    },
    isLinks() {
      this.videoLink = this.isLinks;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;

  i {
    cursor: pointer;
    top: 0;
    right: 0;
    width: 30px;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(var(--alert-color-rgb), 0.1);
    color: var(--alert-color);
  }

  input {
    border-radius: 0 !important;
  }

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}

.video {
  width: 600px;
  aspect-ratio: 16/9;
  iframe {
    width: 100%;
    height: 100%;
    aspect-ratio: 16/9;
  }
}
</style>
